import React from 'react';
import { Box, Container, Typography, Tabs, Tab, Paper } from '@mui/material';
import { Bar, Line } from 'react-chartjs-2';
import { departments, chartOptions, lineChartOptions } from './data';

const TabPanel = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export const PerformanceChartsSection = ({ selectedTab, handleTabChange }) => {
  // Generate chart data from departments
  const growthChartData = {
    labels: departments.map(dept => dept.name),
    datasets: [
      {
        label: 'Growth Rate (%)',
        data: departments.map(dept => dept.metrics.growthRate),
        backgroundColor: '#228B22',
        borderColor: '#1e7a1e',
        borderWidth: 1,
      },
    ],
  };

  const metricsComparisonData = {
    labels: ['Q1', 'Q2', 'Q3', 'Q4'],
    datasets: [
      {
        label: 'Product & Technology',
        data: [65, 72, 78, 87],
        borderColor: '#4caf50',
        backgroundColor: 'rgba(76, 175, 80, 0.2)',
        tension: 0.4,
      },
      {
        label: 'Marketing & Growth',
        data: [58, 69, 75, 82],
        borderColor: '#2196f3',
        backgroundColor: 'rgba(33, 150, 243, 0.2)',
        tension: 0.4,
      },
      {
        label: 'Sales & Business Dev',
        data: [70, 75, 82, 92],
        borderColor: '#ff9800',
        backgroundColor: 'rgba(255, 152, 0, 0.2)',
        tension: 0.4,
      },
      {
        label: 'Customer Success',
        data: [75, 80, 87, 94],
        borderColor: '#9c27b0',
        backgroundColor: 'rgba(156, 39, 176, 0.2)',
        tension: 0.4,
      },
    ],
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #0a1a21 0%, #2a4d5c 100%)',
        py: 10,
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          sx={{
            mb: 6,
            fontWeight: 700,
            color: '#fff',
            textShadow: '0 2px 10px rgba(0,0,0,0.3)',
          }}
        >
          Performance Insights
        </Typography>

        <Paper
          elevation={3}
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            centered
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTab-root': {
                fontWeight: 600,
                fontSize: '1rem',
                textTransform: 'none',
              },
            }}
          >
            <Tab label="Growth Rate" />
            <Tab label="Quarterly Performance" />
          </Tabs>

          <TabPanel value={selectedTab} index={0}>
            <Box sx={{ height: 400 }}>
              <Bar data={growthChartData} options={chartOptions} />
            </Box>
          </TabPanel>

          <TabPanel value={selectedTab} index={1}>
            <Box sx={{ height: 400 }}>
              <Line data={metricsComparisonData} options={lineChartOptions} />
            </Box>
          </TabPanel>
        </Paper>
      </Container>
    </Box>
  );
};

export default PerformanceChartsSection;